module.exports = __webpack_public_path__ + "static/media/fa-music.eba7518c.svg";